import React from 'react';
import PropTypes from 'prop-types';
import { Box, Heading } from '@zillow/constellation';
import { PostsLayout } from '@zillow/zrs-cms';

const RelatedPosts = ({ post }) => {
    if (!post.relatedPosts) {
        return null;
    }

    const isThisPost = (aPost) => aPost.id === post.id;
    const relatedPosts = post.relatedPosts
        .filter((relatedPost) => !isThisPost(relatedPost))
        .slice(0, 3);
    if (relatedPosts.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                backgroundColor: '$colors.brand',
                padding: '$spacing.lg $spacing.sm',
                margin: '0 0 $spacing.md',

                // Tablet
                '@media $md': {
                    padding: '$spacing.xl $spacing.sm',
                    borderRadius: '$radii.xxl',
                    margin: '0 0 $spacing.md',
                },

                // Desktop
                '@media $xl': {
                    padding: '$spacing.xxl $spacing.xl',
                    margin: '0 0 $spacing.xl',
                },
            }}
        >
            <Heading
                level={3}
                fontType={{
                    xs: 'h5',
                    md: 'h4',
                    xl: 'h3',
                }}
                marginBottom={{
                    xs: 'md',
                    md: 'lg',
                }}
                fontColor="white"
                as="p"
            >
                Related Articles
            </Heading>

            <PostsLayout
                layout="INLINE"
                items={relatedPosts.map((relatedPost) => ({
                    id: relatedPost.id,
                    title: relatedPost.title?.raw,
                    url: { href: relatedPost.link },
                    excerpt: relatedPost.excerpt?.raw,
                    alignment: 'vertical',
                    size: 'md',
                    category:
                        relatedPost.primaryCategory ||
                        relatedPost.categories?.[0],
                    forceHideReadTime: true,
                    forceShowCategory: true,
                    image: relatedPost.featuredImage || undefined,
                }))}
            />
        </Box>
    );
};

RelatedPosts.propTypes = {
    post: PropTypes.shape({
        id: PropTypes.number.isRequired,
        relatedPosts: PropTypes.shape({
            posts: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.number.isRequired,
                    link: PropTypes.string.isRequired,
                    title: PropTypes.shape({
                        raw: PropTypes.string,
                    }),
                    excerpt: PropTypes.shape({
                        raw: PropTypes.string,
                    }),
                    primaryCategory: PropTypes.shape({
                        name: PropTypes.string.isRequired,
                    }),
                    categories: PropTypes.arrayOf(
                        PropTypes.shape({
                            name: PropTypes.string.isRequired,
                        })
                    ),
                    featuredImage: PropTypes.shape({
                        alt_text: PropTypes.string,
                        medium: PropTypes.shape({
                            width: PropTypes.number.isRequired,
                            height: PropTypes.number.isRequired,
                            sourceUrl: PropTypes.string.isRequired,
                        }),
                    }),
                })
            ).isRequired,
        }).isRequired,
    }),
};

RelatedPosts.defaultProps = {};

export default RelatedPosts;
